<template>
  <div>
    <b-card-title>
      Upload UGC
    </b-card-title>

    <b-row>
      <b-col cols="12">
        <b-button @click="$refs.file.click()" :disabled="$cannot('product.create') || isLoading" variant="primary" class="mb-3">
          <input
            style="display: none;"
            type="file"
            ref="file"
            @change="pick($event)"
            accept="video/*"
            :disabled="$cannot('product.create')"
          />
          {{ isLoading ? 'Uploading...' : (video ? 'Pick different UGC' : 'Pick UGC')}}
        </b-button>
      </b-col>

      <b-col v-if="video" cols="auto">
        <b-row>
            <video style="width: auto; height: auto; max-width: 100%;" controls muted playsinline>
              <source :src="video">
            </video>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { products } from '@/api'

export default {
  name: 'Ugc',
  components: {},
  props: { product: Object },
  inject: ['$cannot'],

  data() {
    return {
      video: '',
      blob: null,
      isLoading: false,
    }
  },

  watch: {
    product() {
      this.preload()
    },
  },

  beforeMount() {
    this.preload()
  },

  methods: {
    async preload() {
      this.video = this.product.ugc?.video ?? ''
    },

    pick(event) {
      const input = event.target

      if (input.files && input.files[0]) {
        const reader = new FileReader()
        reader.addEventListener('load', event => {
          this.nextStep()
          this.video = event.target.result
          this.blob = input.files[0]
          this.upload()
        })
        reader.readAsDataURL(input.files[0])
      }
    },

    nextStep() {
      if (this.currentStep === this.totalSteps) {
        return
      }

      return this.$router.push({
        name: 'products.edit.images',
        query: { step: this.currentStep + 1 },
      })
    },

    async upload() {
      this.isLoading = true;

      await this.$store.dispatch('auth/refreshToken');
      const product = await products.gallery(this.product.id).addUgc({ ugc: this.blob })

      if (!product.data) {
        this.$bvToast.toast(product.errors?.join('; '), {
          title: 'Something went wrong...',
          variant: 'danger',
        })
      } else {
        this.video = product.data.ugc?.video
        this.$bvToast.toast('UGC uploaded successfully.', {
          title: 'UGC uploaded',
          variant: 'primary',
        })
      }

      this.isLoading = false;

      this.$emit('updated')
    },
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
